/* SECOND SPRING — header: mobile drawer menu + cart count bubble.
   IIFE, no libraries. Inits on DOMContentLoaded and shopify:section:load,
   double-init guarded with a dataset flag. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function initHeader(header) {
    if (header.dataset.ssInit === 'true') return;
    header.dataset.ssInit = 'true';

    var openBtn = header.querySelector('[data-ss-menu-open]');
    var drawer = header.querySelector('[data-ss-menu]');
    var panel = drawer ? drawer.querySelector('.ss-header__drawer-panel') : null;
    var lastFocused = null;

    function isOpen() {
      return drawer && !drawer.hidden;
    }

    function openMenu() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      drawer.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
      });
      document.documentElement.classList.add('ss-scroll-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (panel) panel.focus();
    }

    function closeMenu() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      document.documentElement.classList.remove('ss-scroll-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    if (openBtn && drawer) {
      openBtn.addEventListener('click', openMenu);

      drawer.addEventListener('click', function (event) {
        if (event.target.closest('[data-ss-menu-close]')) closeMenu();
        // navigating away: let the link work, but release the lock
        if (event.target.closest('a[href]')) closeMenu();
      });

      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          closeMenu();
          return;
        }
        if (event.key !== 'Tab' || !panel) return;
        var focusable = panel.querySelectorAll(FOCUSABLE);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // Close on section unload in the customizer so the scroll lock never leaks.
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(header) && isOpen()) closeMenu();
    });
  }

  function updateCounts(count) {
    var bubbles = document.querySelectorAll('[data-ss-cart-count]');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = String(count);
      bubbles[i].hidden = count === 0;
    }
    var live = document.querySelectorAll('[data-ss-cart-count-a11y]');
    for (var j = 0; j < live.length; j++) {
      live[j].textContent = count + ' items in cart';
    }
  }

  function initAll() {
    var headers = document.querySelectorAll('[data-ss-header]');
    for (var i = 0; i < headers.length; i++) initHeader(headers[i]);
  }

  if (!document.documentElement.dataset.ssHeaderGlobal) {
    document.documentElement.dataset.ssHeaderGlobal = 'true';
    // The cart drawer dispatches this after every successful cart mutation or refresh.
    document.addEventListener('ss:cart:updated', function (event) {
      if (event.detail && typeof event.detail.count === 'number') {
        updateCounts(event.detail.count);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
